var _rect, _rect2, _rect3, _rect4, _circle, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlatTentaclesLeft = function SvgFlatTentaclesLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 329 487"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 211.935,
    height: 42.587,
    x: 96.98,
    y: 447.635,
    stroke: "currentColor",
    strokeWidth: 1.499,
    opacity: 0.5,
    rx: 21.293,
    transform: "rotate(-60.5 96.98 447.635)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 345.695,
    height: 42.587,
    x: 1.022,
    y: 464.878,
    stroke: "currentColor",
    strokeWidth: 1.499,
    opacity: 0.5,
    rx: 21.293,
    transform: "rotate(-60.5 1.022 464.878)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 99.038,
    height: 42.587,
    x: 215.498,
    y: 238.228,
    stroke: "currentColor",
    strokeWidth: 1.499,
    opacity: 0.5,
    rx: 21.293,
    transform: "rotate(-60 215.498 238.228)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 127.495,
    height: 44.086,
    x: 226.546,
    y: 370.521,
    fill: "currentColor",
    rx: 22.043,
    transform: "rotate(-60.5 226.546 370.521)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 303.19,
    cy: 133.763,
    r: 18.894,
    fill: "currentColor",
    transform: "rotate(-60 303.19 133.763)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 260.856,
    height: 44.086,
    x: 42.882,
    y: 233.614,
    fill: "currentColor",
    rx: 22.043,
    transform: "rotate(-60.5 42.882 233.614)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 164.328,
    height: 44.086,
    x: 182.122,
    y: 143.024,
    fill: "currentColor",
    rx: 22.043,
    transform: "rotate(-60.5 182.122 143.024)"
  })));
};
export default SvgFlatTentaclesLeft;